import clsx from 'clsx';
import { string } from 'prop-types';

import { isLink } from 'helpers';
import { appService } from 'services';

import defaultArrivajImg from 'assets/img/default-arrivaj-img.png';
import defaultTouloisirsImg from 'assets/img/default-touloisirs-img.png';

const ApiImg = ({ src = '', alt = '', width = '500', height = '300', className = '' }) => {
  const getUrl = (url) => (isLink(url) ? url : `${process.env.REACT_APP_CASTELIS_TUNNEL_URL}${url}`);
  const handleError = (event) => {
    event.target.src = appService.isTouloisirs() ? defaultTouloisirsImg : defaultArrivajImg;
    if (appService.isArrivaj()) {
      event.target.classList.remove('object-cover');
      event.target.classList.add('object-contain');
    }
  };
  return (
    <img
      src={getUrl(src)}
      className={clsx('w-full h-full object-cover', className)}
      alt={alt}
      width={width}
      height={height}
      onError={handleError}
    />
  );
};

ApiImg.propTypes = {
  src: string,
  alt: string,
  width: string,
  height: string,
  className: string
};

export default ApiImg;
